import { useAuth } from "../../auth/context";
import { Box } from "@mui/material";
import _ from "lodash";

const Logo = () => {
  const { user } = useAuth();
  const healthCenter = _.get(user, "profile.healthCenter");
  if (_.isEmpty(healthCenter) || !healthCenter.logoUrl) return null;

  return (
    <Box
      sx={{
        alignSelf: { md: "stretch" },
        display: "flex",
        alignItems: "center",
        justifyContent: { xs: "center", md: "flex-start" },
        flexShrink: 0,
        width: { xs: "100%", md: "auto" },
        borderLeft: { md: "1.5px solid" },
        borderColor: { md: "grey.200" },
        pl: { md: 3.5 },
        ml: { md: 3.5 },
        mt: { xs: 1.5, md: 0 },
      }}
    >
      <Box
        component="img"
        src={healthCenter.logoUrl}
        alt={healthCenter.name}
        sx={{
          display: "block",
          maxHeight: { xs: 72, md: 80 },
          maxWidth: { xs: 220, md: 280 },
        }}
      />
    </Box>
  );
};

export default Logo;
